import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "app" }
const _hoisted_2 = {
  key: 0,
  class: "page-order"
}
const _hoisted_3 = {
  key: 2,
  class: "app-version"
}

import {useI18n} from 'vue-i18n';
import {IonApp, IonRouterOutlet} from '@ionic/vue';
import {computed, onBeforeMount, ref} from 'vue';
import OrderComponent from '@/components/OrderComponent.vue';
import NavigationComponent from '@/components/NavigationComponent.vue';
import LanguageSelectorPopup from '@/components/LanguageSelectorPopup.vue';
import {toKebabCase} from "@/functions";
import axios from 'axios';
import router from '@/router';
import ErrorMessage from '@/components/ErrorMessage.vue';
import {CartStore} from './stores/cart';
import {AppStore} from './stores/app';
import {OrderStore} from './stores/order';
import {AuthStore} from "@/stores/auth";
import UpdateComponent from "@/components/UpdateComponent.vue";
import LoaderComponent from "@/components/LoaderComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const {locale} = useI18n();

const cartStore = CartStore();
const appStore = AppStore();
const orderStore = OrderStore();
const authStore = AuthStore();


axios.defaults.headers.common['Content-Type'] = 'application/json';

const showOrder = computed<boolean>(() => {
  const showCart = router.currentRoute.value.meta.showCart as boolean;
  if(!showCart) {
    return false;
  }

  return cartStore.state.visible && (cartStore.state.items.length > 0
      || appStore.state.isLargeScreen
      || (appStore.state.currentPage != null
          && typeof appStore.state.currentPage == "string" && ['editOrder', 'articlePage'].includes(appStore.state.currentPage)));
});

onBeforeMount(() => {
  document.documentElement.setAttribute("lang", locale.value);

  orderStore.removeExpiredOrders()
  //If there are unpaid orders that are not ready yet
  if (orderStore.state.paidOrders.length) {
    orderStore.pullOrderStatus();
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), {
    class: _normalizeClass(_unref(toKebabCase)(_unref(router).currentRoute.value.name?.toString() ??''))
  }, {
    default: _withCtx(() => [
      _createVNode(NavigationComponent),
      _createVNode(ErrorMessage),
      _createVNode(UpdateComponent),
      _createElementVNode("div", _hoisted_1, [
        (_unref(showOrder))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(OrderComponent)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(LanguageSelectorPopup),
      (!_unref(authStore).state.loading)
        ? (_openBlock(), _createBlock(_unref(IonRouterOutlet), { key: 0 }))
        : _createCommentVNode("", true),
      (!_unref(authStore).state.loading)
        ? (_openBlock(), _createBlock(LoaderComponent, { key: 1 }))
        : _createCommentVNode("", true),
      (_unref(cartStore).state.settings)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Version: " + _toDisplayString(_unref(cartStore).state.settings.version), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})